import React from 'react';
// 🛑 CORREÇÃO 1: Adicionar 'Outlet' para o roteamento aninhado (Pacientes)
import { Routes, Route, Navigate, Outlet } from 'react-router-dom'; 
import { useAuth } from './context/AuthContext'; 

// CAMINHOS DE IMPORTAÇÃO DE COMPONENTES DE ESTRUTURA
import DashboardLayout from './layouts/DashboardLayout'; 
import PrivateRoute from './components/PrivateRoute'; 

// Páginas de Autenticação
import LoginPage from './pages/Auth/LoginPage';
import ForgotPasswordPage from './pages/Auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/Auth/ResetPasswordPage';
import InitialLoadingPage from './pages/Auth/InitialLoadingPage'; 

// Páginas Públicas
import LandingPage from './pages/LandingPage/LandingPage';
import PricingPage from './pages/LandingPage/PricingPage';
import ContactPage from './pages/LandingPage/ContactPage';
import TermsPage from './pages/LandingPage/TermsPage';
import PrivacyPolicyPage from './pages/LandingPage/PrivacyPolicyPage';
import AboutPage from './pages/LandingPage/AboutPage';
import RecursosPage from './pages/LandingPage/RecursosPage';
import DemonstracaoPage from './pages/LandingPage/DemonstracaoPage';
import ThankYouPage from './pages/LandingPage/ThankYouPage';
import DepoimentosPage from './pages/LandingPage/DepoimentosPage';
import AjudaPage from './pages/LandingPage/AjudaPage';
import PlanosRegistroPontoPage from './pages/LandingPage/PlanosRegistroPontoPage';

// Páginas de Dashboard e Perfil
import DashboardPage from './pages/Dashboard/DashboardPage';
import ProfilePage from './pages/User/ProfilePage'; 

// Páginas de Configuração
import RbacConfigPage from './pages/Config/RbacConfigPage'; 

// Páginas de Gerenciamento
import UsuariosPage from './pages/Management/UsuariosPage';
import VincularPacientesPage from './pages/Management/VincularPacientesPage';
import MedicamentoPage from './pages/Management/MedicamentoPage';
import EquipamentoPage from './pages/Management/EquipamentoPage';

// Páginas Operacionais
import PacientesPage from './pages/Pacientes/PacienteList'; 
import PacienteProntuarioPage from './pages/Pacientes/PacienteProntuarioPage';
import PlanoMedicoPacientePage from './pages/Pacientes/PlanoMedicoPacientePage';
import ProfissionalProntuarioPage from './pages/Profissionais/ProfissionalProntuarioPage'; 

import AgendamentosPage from './pages/Agendamentos/Agendamentos'; 
import DashboardPonto from './pages/Ponto/DashboardPonto'; 
import DiarioCuidadosPage from './pages/Diario/DiarioCuidadosPage';
import PlanoMedicoPage from './components/PlanoMedico/PlanoMedicoPage';
import { AgendaTarefasPage } from './pages/AgendaTarefas/AgendaTarefasPage';
import FinanceiroPage from './pages/Financeiro/FinanceiroPage';
import ConfigFinanceiroPage from './pages/Financeiro/ConfigFinanceiroPage';
import ContasPagarPage from './pages/Financeiro/ContasPagarPage';
import ContasReceberPage from './pages/Financeiro/ContasReceberPage';
import DashboardFinanceiro from './pages/Financeiro/DashboardFinanceiro';
import HistoricoTransacoesPage from './pages/Financeiro/HistoricoTransacoesPage';
import AIAssistantPage from './pages/AIAssistant/AIAssistantPage';
import SucessoPage from './pages/Assinatura/SucessoPage';
import FalhaPage from './pages/Assinatura/FalhaPage';
import PendentePage from './pages/Assinatura/PendentePage';
import SemAssinaturaPage from './pages/Assinatura/SemAssinaturaPage';
import GerenciarAssinaturaPage from './pages/Assinatura/GerenciarAssinaturaPage';
import CheckoutPage from './pages/Assinatura/CheckoutPage';
import EscalaPlantao from './pages/Escalas/EscalaPlantao';
import DetalhesEscalaPage from './pages/Escalas/DetalhesEscalaPage';
import AdminAssinaturasPage from './pages/Admin/AdminAssinaturasPage';

// =========================================================
// Componente Principal de Roteamento
// =========================================================

const AppRoutes = () => {
    const { isAuthenticated, loading, isInitialLoadAfterLogin } = useAuth(); 

    // Mostrar página interativa de carregamento inicial após login
    // Mostra enquanto isInitialLoadAfterLogin for true (mesmo que loading seja false temporariamente)
    if (isInitialLoadAfterLogin) {
        return <InitialLoadingPage />;
    }

    // Carregamento normal (não após login)
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <p className="text-emerald-600 font-semibold text-lg">Carregando permissões...</p>
            </div>
        ); 
    }

    return (
        <Routes>
            
            {/* 1. ROTAS PÚBLICAS */}
            
            {/* Rota Raiz (/) agora decide entre Landing Page ou Dashboard */}
            <Route 
                path="/" 
                // 🛑 CORREÇÃO 2: Garantir que '/' seja LandingPage se não autenticado
                element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LandingPage />} 
            />

            <Route 
                path="/login" 
                element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />} 
            />
            <Route path="/register" element={<Navigate to="/contato" replace />} />
            <Route path="/register-org" element={<Navigate to="/contato" replace />} />
            <Route 
                path="/forgot-password" 
                element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <ForgotPasswordPage />} 
            />
            <Route 
                path="/reset-password" 
                element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <ResetPasswordPage />} 
            />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/recursos" element={<RecursosPage />} />
            <Route path="/contato" element={<ContactPage />} />
            <Route path="/demonstracao" element={<DemonstracaoPage />} />
            <Route path="/obrigado" element={<ThankYouPage />} />
            <Route path="/termos" element={<TermsPage />} />
            <Route path="/privacidade" element={<PrivacyPolicyPage />} />
            <Route path="/sobre-nos" element={<AboutPage />} />
            <Route path="/depoimentos" element={<DepoimentosPage />} />
            <Route path="/ajuda" element={<AjudaPage />} />
            <Route path="/planos/registro-de-ponto" element={<PlanosRegistroPontoPage />} />
            
            {/* Rotas de Assinatura (Públicas - podem ser acessadas sem autenticação) */}
            <Route path="/assinatura/checkout" element={<CheckoutPage />} />
            <Route path="/assinatura/sucesso" element={<SucessoPage />} />
            <Route path="/config/assinatura/sucesso" element={<SucessoPage />} />
            <Route path="/config/assinatura/falha" element={<FalhaPage />} />
            <Route path="/config/assinatura/pendente" element={<PendentePage />} />
            <Route path="/config/assinatura/sem-assinatura" element={<SemAssinaturaPage />} />
            
            {/* 2. ROTAS PRIVADAS (ENVOLVIDAS PELO LAYOUT) */}
            <Route element={<DashboardLayout />}> 
                
                {/* ROTAS SIMPLES: Usam PrivateRoute com o componente diretamente */}
                    
                {/* Rota de Dashboard */}
                <Route 
                    path="/dashboard" 
                    element={<PrivateRoute requiredResource="dashboard" component={DashboardPage} />} 
                />

                {/* Rota de Tarefas Agendadas */}
                <Route
                    path="/tarefas"
                    element={<PrivateRoute requiredResource="agenda_tarefas" component={AgendaTarefasPage} />}
                />
                
                {/* Rota de Perfil do Usuário - Apenas autenticação necessária */}
                <Route 
                    path="/profile" 
                    element={<PrivateRoute component={ProfilePage} />} 
                />
                
                {/* Rotas de Gerenciamento e Operação */}
                <Route 
                    path="/usuarios" 
                    element={<PrivateRoute requiredResource="usuarios" component={UsuariosPage} />}
                />
                <Route 
                    path="/usuarios/vinculos-pacientes" 
                    element={<PrivateRoute requiredResource="usuarios" component={VincularPacientesPage} />}
                />
                <Route 
                    path="/profissionais/:profissionalid/prontuario" 
                    element={<PrivateRoute requiredResource="usuarios" component={ProfissionalProntuarioPage} />}
                />
                <Route 
                    path="/agendamentos" 
                    element={<PrivateRoute requiredResource="agendamentos" component={AgendamentosPage} />}
                />
                <Route 
                    path="/medicamentos" 
                    element={<PrivateRoute requiredResource="medicamentos" component={MedicamentoPage} />}
                />
                <Route 
                    path="/equipamentos" 
                    element={<PrivateRoute requiredResource="equipamentos" component={EquipamentoPage} />}
                />
                <Route 
                    path="/diario" 
                    element={<PrivateRoute requiredResource="diario" component={DiarioCuidadosPage} />}
                />
                <Route 
                    path="/ponto" 
                    element={<PrivateRoute requiredResource="check_in_out" component={DashboardPonto} />}
                />
                <Route 
                    path="/config/permissoes" 
                    element={<PrivateRoute requiredResource="config" component={RbacConfigPage} />}
                />
                <Route 
                    path="/config/assinatura/gerenciar" 
                    element={<PrivateRoute component={GerenciarAssinaturaPage} />}
                />
                <Route 
                    path="/admin/assinaturas" 
                    element={<PrivateRoute component={AdminAssinaturasPage} />}
                />
                <Route 
                    path="/financeiro" 
                    element={<PrivateRoute requiredResource="financeiro" component={FinanceiroPage} />}
                />
                <Route 
                    path="/financeiro/dashboard" 
                    element={<PrivateRoute requiredResource="financeiro" component={DashboardFinanceiro} />}
                />
                <Route 
                    path="/financeiro/contas-pagar" 
                    element={<PrivateRoute requiredResource="financeiro" component={ContasPagarPage} />}
                />
                <Route 
                    path="/financeiro/configuracoes" 
                    element={<PrivateRoute requiredResource="financeiro" component={ConfigFinanceiroPage} />}
                />
                <Route 
                    path="/financeiro/contas-receber" 
                    element={<PrivateRoute requiredResource="financeiro" component={ContasReceberPage} />}
                />
                <Route 
                    path="/financeiro/historico"
                    element={<PrivateRoute requiredResource="financeiro" component={HistoricoTransacoesPage} />}
                />
                <Route 
                    path="/assistente-ia" 
                    element={<PrivateRoute requiredResource="ia" component={AIAssistantPage} />}
                />
                <Route 
                    path="/escalas" 
                    element={<PrivateRoute requiredResource="agendamentos" component={EscalaPlantao} />}
                />
                <Route 
                    path="/escalas/:id" 
                    element={<PrivateRoute requiredResource="agendamentos" component={DetalhesEscalaPage} />}
                />

                {/* 🛑 ROTAS ANINHADAS PARA PACIENTES (LISTA E SUB-ROTAS) */}
                {/* O PrivateRoute PAI checa a permissão de 'pacientes' e renderiza <Outlet /> */}
                <Route 
                    path="/pacientes" 
                    element={<PrivateRoute requiredResource="pacientes"><Outlet /></PrivateRoute>}
                >
                    {/* Index (path: /pacientes) -> PacienteList */}
                    <Route index element={<PacientesPage />} /> 

                    {/* Prontuário (path: /pacientes/:pacienteid/prontuario) */}
                    {/* 🛑 CORREÇÃO 3: Path relativo e sem o PrivateRoute extra */}
                    <Route 
                        path=":pacienteid/prontuario" 
                        element={<PacienteProntuarioPage />} 
                    />
                    
                    {/* Planos Médicos (path: /pacientes/:pacienteId/planos) */}
                    <Route
                        path=":pacienteId/planos"
                        element={<PlanoMedicoPacientePage />}
                    />

                </Route>
                
            </Route>
            
            {/* 3. Rota 404 (Wildcard) */}
            <Route path="*" element={<Navigate to="/" replace />} />
            
        </Routes>
    );
};

export default AppRoutes;